import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { ApplicationConfig, DEFAULT_CURRENCY_CODE, LOCALE_ID } from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideAnimations } from '@angular/platform-browser/animations';
import { APP_CONFIG, AppConfig, AUTH_CONFIG, HttpInterceptorService, initDayjs } from '@ng-shared';

initDayjs();
import { appRoutes } from './app.routes';

const postAPIsToNotCache: string[] = [
  '/vendorBooking/search',
]

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    // provideClientHydration(withHttpTransferCacheOptions({
    //   includePostRequests: true,
    //   filter: (req) => !postAPIsToNotCache.some(api => req.url.includes(api)),
    // })),
    provideRouter(appRoutes, withPreloading(PreloadAllModules)),
    provideAnimations(),

    { provide: LOCALE_ID, useValue: 'en-ZA' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'R' },
    // { provide: ErrorHandler, useClass: ErrorHandlerService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: APP_CONFIG,
      useValue: { brandTheme: 'optimal', logoSrc: 'assets/logos/specsfin-logo-transparent.svg' } satisfies AppConfig,
    },
    {
      provide: AUTH_CONFIG,
      useValue: {
        authInvalidRedirectUrl: '/public',
        authLoginUrl: '/public/login',
        authLogoutUrl: '/public/logout',
        authForgotPasswordUrl: '/forgot-password',
        application: 'atlantis-vault',
      },
    },
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
  ],
};
